import { render, staticRenderFns } from "./DeleteConfirmationModal.vue?vue&type=template&id=b8e0ac50&scoped=true"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=b8e0ac50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e0ac50",
  null
  
)

export default component.exports